import {
  AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject,
  Input, OnDestroy, OnInit, Output, PLATFORM_ID, ViewChild, ViewEncapsulation
} from '@angular/core';
import { isPlatformBrowser, NgStyle } from '@angular/common';

import { fromEvent, Subscription } from 'rxjs';
import { v4 as uuid } from 'uuid';
import { TranslateModule } from '@ngx-translate/core';

import {
  DeviceService, ISdFormComponentItem, SdFormCheckboxComponent, SdFormErrorComponent, SdFormSelectComponent, SdProductCustomerComponent
} from '@seb/web-design-system/core';

import type { IOrderReturnDetail, IOrderReturnDetailProduct } from './order-return-detail.interface';
import type { IOrderProduct } from '../../order-details/order-details.interface';

@Component({
  selector: 'sd-order-return-detail',
  templateUrl: './order-return-detail.component.html',
  styleUrls: ['./order-return-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdFormCheckboxComponent,
    NgStyle,
    SdProductCustomerComponent,
    SdFormSelectComponent,
    SdFormErrorComponent,
    TranslateModule
  ]
})
export class SdOrderReturnDetailComponent
implements AfterViewInit, OnInit, OnDestroy
{
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService,
  ) {}

  uuidSelect: string = uuid();
  checkValue: boolean;
  itemQty: ISdFormComponentItem[];
  alignItems: number;
  isTablet$: boolean;
  tabletSubscription: Subscription;
  windowResizeSubscription: Subscription;

  @Input()
  returnListConfig: IOrderReturnDetail;

  @Input()
  readonly = false;

  @Output()
  selectedProduct = new EventEmitter<IOrderReturnDetailProduct>();

  @Output()
  deselectedProduct = new EventEmitter<string>();

  @Input()
  product: IOrderProduct;

  @Output()
  openRecommendedPriceModal = new EventEmitter<void>();

  @ViewChild('reasonSelector')
  reasonSelector: SdFormSelectComponent<number>;

  @ViewChild('qtySelector')
  qtySelector: SdFormSelectComponent<number>;

  @ViewChild('productCustomer')
  productCustomer: SdProductCustomerComponent;

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.tabletSubscription = this.deviceService.isTablet.subscribe((x) => {
        this.isTablet$ = x;
      });

      this.windowResizeSubscription = fromEvent(window, 'resize').subscribe(
        () => {
          this.alignItems =
            this.productCustomer.productCustomerMedia().nativeElement.getBoundingClientRect()
              .height / 2;
        },
      );
    }
  }

  ngAfterViewInit() {
    this.itemQty = Array(this.product.productInfo.quantity)
      .fill('')
      .map((x, i) => {
        return {
          value: i + 1
        };
      });

    this.alignItems =
      this.productCustomer.productCustomerMedia().nativeElement.getBoundingClientRect()
        .height / 2;
  }

  ngOnDestroy() {
    this.tabletSubscription?.unsubscribe();
    this.windowResizeSubscription?.unsubscribe();
  }

  updateReason() {
    if (this.reasonSelector) {
      this.selectedProduct.emit({
        reason: this.reasonSelector.internalField.value,
        quantity: this.qtySelector.internalField.value,
        productCode: this.product.productInfo.code
      });
    }
  }

  toggleCheck() {
    if (!this.readonly) {
      this.checkValue = !this.checkValue;
      this.checkedChange();
    }
  }

  checkedChange() {
    if (!this.checkValue) {
      this.deselectedProduct.emit(this.product.productInfo.code);
    }
  }

  onopenRecommendedPriceModal() {
    this.openRecommendedPriceModal.emit();
  }
}
